import { Field } from '@ui/components/Field';
import { DollarSignIcon } from '@ui/components/Icons';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useSelector } from '@ui/hooks/useSelector';

import { useQuotePriceContext } from './QuotePriceProvider';

export function PriceAdjustmentAmount() {
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();
  const { value } = useSelector((state) =>
    selectQuotePriceField(
      state,
      quoteLineUuid,
      quotePriceUuid,
      'priceAdjustmentAmount',
    ),
  );

  return (
    <Field
      label="Price Adjustment"
      showLabel={isFirstQuotePrice}
      leftIcon={DollarSignIcon}
      value={value}
      type="number"
      isDisabled
    />
  );
}
